import React from 'react';
import { CommanderStatusAPI } from '../api/CommanderStatusAPI';
import { COMMANDER_VOLATILE_DATA_POOLING_INTERVAL } from '../../api/Constants';
import { skipToken } from '@reduxjs/toolkit/query';
import { useAllDevices } from '../../hooks/useAllDevices';

function useCommanderStatus(commanderId = '') {
  const { data: devicesStructure, ...restDevices } = useAllDevices();
  const commandersIds = devicesStructure?.result;
  return CommanderStatusAPI.useGetCommandersStatusQuery(
    commandersIds ?? skipToken,
    {
      skip: !commandersIds?.length,
      pollingInterval: COMMANDER_VOLATILE_DATA_POOLING_INTERVAL,
      selectFromResult: ({ data, ...rest }) => {
        const commanderStatus = data?.entities[commanderId];
        return {
          ...rest,
          data: data,
          commanderStatus,
        };
      },
    }
  );
}

export default useCommanderStatus;
